import React, { Component } from "react";

const patterns = [
    "//\\", "\\\\/", "\\//", "/\\\\", "/\\/", "\\/\\"
];

export default class PatternPairs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pairs: this.getPairs(props.pairsNeeded)
        };
    }

    getPairs(pairsNeeded) {
        const pairs = new Array(pairsNeeded);
        const length = patterns.length;
        const samePairs = Math.floor(pairsNeeded / 5);
        let lastItem1Index = 0;
        let lastItem2Index = 0;
        let i;

        // randomly assign patterns
        // consecutive Item1 should not be the same
        // consecutive Item2 should not be the same
        // Item1 and Item2 should not be the same (not yet)

        for (i = 0; i < pairsNeeded; i++) {

            let item1Index;
            let item2Index;

            do {
                item1Index = Math.floor(Math.random() * length);
            } while (item1Index === lastItem1Index);

            do {
                item2Index = Math.floor(Math.random() * length);
            } while (item1Index === item2Index || item2Index === lastItem2Index);

            pairs[i] = { item1: patterns[item1Index], item2: patterns[item2Index] };

            lastItem1Index = item1Index;
            lastItem2Index = item2Index;
        }

        const same = new Array(pairsNeeded);

        // ensure some patterns are the same
        // don't make the patterns the same again for any entry

        for (i = 0; i < samePairs; i++) {
            let j;

            do {
                j = Math.floor(Math.random() * pairsNeeded);
            } while (same[j]);

            pairs[j].item2 = pairs[j].item1;

            same[j] = true;
        }

        return pairs;
    }

    render() {
        const checked = this.props.checked ? " checked" : "";
        const pairIndex = this.props.pairIndex;
        const pairs = this.state.pairs;

        const text1 = pairIndex === -1 ? patterns[0] : pairs[pairIndex].item1;
        const text2 = pairIndex === -1 ? patterns[1] : pairs[pairIndex].item2;

        return (
        <div className="patterns">
            <div className={'pattern pattern-01' + checked}><span>{text1}</span></div>
            <div className={'pattern pattern-02' + checked}><span>{text2}</span></div>
        </div>
        );
    }
}

